import { useState } from "react";
import { Button, Container } from "reactstrap";
import { useNavigate,   } from "react-router-dom";
import {
    Menu,
    X,
    LogIn, 
    User
} from "lucide-react";
import { useAuth } from "../../context/AuthContext";
import "./NavHeader.css";

const NavHeader = () => {

    const navigate = useNavigate();
    const { role } = useAuth();

    const {
        isAuthenticated, 
    } = useAuth();

    const [isOpen, setIsOpen] = useState(false);

   

    return (

        <header className="nav-header">

            <Container>

                <div className="header-container">

                    <a
                        href="/"
                        className="link"
                    >
                        <h2 className="price-logo">

                            Price<span style={{color:"#38b6ff"}} >Worth<span style={{ color: "black" }}>™</span></span>

                        </h2>
                    </a>

                    <button
                        className="mobile-toggle"
                        onClick={() =>
                            setIsOpen(!isOpen)
                        }
                    >

                        {
                            isOpen
                                ? <X size={28} />
                                : <Menu size={28} />
                        }

                    </button>

                    <nav className={`nav-menu ${isOpen ? "open" : ""}`}>

                        <button
                            className="nav-btn"
                           
                            onClick={() => {
                                setIsOpen(false);
                                navigate("/")}}
                        >
                            Home
                        </button>


                        {isAuthenticated &&
                            (role === "Admin" ||
                                role === "SuperAdmin" ||
                                role === "Coordinator") && (
                                <button
                                    className="nav-btn"
                                    onClick={() => {
                                         setIsOpen(false);
                                        if (role === "Admin" || role === "SuperAdmin") {
                                            navigate("/admin");
                                        } else if (role === "Coordinator") {
                                            navigate("/coordinator");
                                        }
                                    }}
                                >
                                    Dashboard
                                </button>
                            )}

                        <button
                            className="nav-btn"
                            onClick={() => { 
                                setIsOpen(false);
                                navigate("/about")
                            }}
                        >
                            About
                        </button>
<button
                            className="nav-btn"
                            onClick={() =>{ 
                                setIsOpen(false);
                                 navigate("/contact")
                                }}
                        >
                            Contact
                        </button>
                        {

                            !isAuthenticated ?

                                <button
                                    className="login-btn"
                                    onClick={() =>
                                    {
                                        setIsOpen(false);
                                        navigate("/login")
                                    }}
                                >

                                    <LogIn size={18} />

                                    Login

                                </button>

                                :

                                <div className="profile-section">

                                    <Button
                                        color="primary" outline
                                        onClick={() => navigate("/user/mygroup")}
                                        title="My Profile"
                                        style={{
                                            width: "40px",
                                            height: "40px",
                                            borderRadius: "50%",
                                            fontSize: "42px",
                                            fontWeight: "bold",
                                            display: "flex",
                                            justifyContent: "center",
                                            alignItems: "center",
                                            margin: "0 auto",
                                            padding: "5px",
                                            marginRight: "8px"
                                        }}
                                    >

                                        <User size={20} />
                                    </Button>


                                  

                                </div>

                        }

                    </nav>

                </div>

            </Container>

        </header>

    );

};

export default NavHeader;